// AmountPicker.jsx — grid de montos preset + monto libre + equivalencia,
// más el hook de estado que comparten PersonaPanel y EmpresaPanel.

import React from 'react'
import { fmtCLP, fmtHeight } from '../shared.jsx'

const { useState } = React;

const PRESETS = [3000, 5000, 10000, 25000, 50000, 100000, 200000];

function parseAmountInput(raw) {
  const digits = raw.replace(/\D/g, "");
  return digits ? parseInt(digits, 10) : 0;
}

function useAmountPicker(initial) {
  const [amount, setAmount] = useState(initial);
  const [custom, setCustom] = useState("");
  const finalAmount = custom ? parseAmountInput(custom) : amount;

  function selectAmount(v) {
    setAmount(v);
    setCustom("");
  }

  function reset() {
    setAmount(initial);
    setCustom("");
  }

  return { amount, custom, finalAmount, selectAmount, setCustom, reset };
}

function AmountPicker({ presets, amount, custom, finalAmount, onSelect, onCustomChange }) {
  return (
    <div style={{ display: "flex", flexDirection: "column", gap: 12 }}>
      <div className="amount-grid">
        {presets.map((p) => (
          <button
            key={p}
            type="button"
            className={`amount-chip ${!custom && amount === p ? "active" : ""}`}
            onClick={() => onSelect(p)}
          >
            ${fmtCLP(p)}
          </button>
        ))}
      </div>
      <div className="field-wrap">
        <span className="field-prefix">$</span>
        <input
          type="text"
          inputMode="numeric"
          value={custom}
          onChange={(e) => onCustomChange(e.target.value)}
          placeholder="Otro monto"
          className="field field-amount"
        />
      </div>
    </div>
  );
}

export { PRESETS, parseAmountInput, useAmountPicker, AmountPicker };
